/* MORAY PDP: fit the actual garment, not the empty canvas around it.
 * Only plain light/transparent studio backgrounds qualify. Lifestyle photos
 * keep their cover treatment. No catalogue writes or extra image downloads.
 */
(function () {
  'use strict';

  function studioBounds(pixels, width, height) {
    var count = width * height;
    var corners = [[], [], []];
    var transparent = 0;
    var samples = 0;
    var patch = Math.max(2, Math.round(Math.min(width, height) * 0.05));
    function rgb(index, channel) {
      var alpha = pixels[index * 4 + 3] / 255;
      return pixels[index * 4 + channel] * alpha + 255 * (1 - alpha);
    }
    for (var y = 0; y < height; y++) {
      for (var x = 0; x < width; x++) {
        if ((x < patch || x >= width - patch) && (y < patch || y >= height - patch)) {
          var index = y * width + x;
          samples++;
          if (pixels[index * 4 + 3] < 24) transparent++;
          for (var channel = 0; channel < 3; channel++) corners[channel].push(rgb(index, channel));
        }
      }
    }
    var bg = corners.map(function (values) {
      values.sort(function (a, b) { return a - b; });
      return values[Math.floor(values.length / 2)];
    });
    var alphaBackground = transparent / samples >= 0.75;
    if (!alphaBackground && (Math.min.apply(null, bg) < 195 || Math.max.apply(null, bg) - Math.min.apply(null, bg) > 24)) return null;

    function background(index) {
      if (pixels[index * 4 + 3] < 24) return true;
      if (alphaBackground) return false;
      var distance = 0;
      for (var c = 0; c < 3; c++) {
        var delta = rgb(index, c) - bg[c];
        distance += delta * delta;
      }
      return distance < 16 * 16;
    }
    var visited = new Uint8Array(count);
    var queue = new Int32Array(count);
    var head = 0;
    var tail = 0;
    var edgeCount = 0;
    var edgeBackground = 0;
    function enqueue(index) {
      if (!visited[index] && background(index)) {
        visited[index] = 1;
        queue[tail++] = index;
      }
    }
    for (var i = 0; i < count; i++) {
      if (i < width || i >= count - width || i % width === 0 || i % width === width - 1) {
        edgeCount++;
        if (background(i)) edgeBackground++;
        enqueue(i);
      }
    }
    if (edgeBackground / edgeCount < 0.75) return null;
    while (head < tail) {
      var current = queue[head++];
      var col = current % width;
      if (col > 0) enqueue(current - 1);
      if (col < width - 1) enqueue(current + 1);
      if (current >= width) enqueue(current - width);
      if (current < count - width) enqueue(current + width);
    }
    if (tail / count < 0.18) return null;

    // Discard isolated compression noise, retain every substantial component
    // (e.g. both shoes), including shadows connected to the garment.
    var left = width;
    var top = height;
    var right = -1;
    var bottom = -1;
    var foreground = 0;
    var minComponent = Math.max(4, Math.floor(count * 0.0004));
    for (var seed = 0; seed < count; seed++) {
      if (visited[seed]) continue;
      head = 0;
      tail = 1;
      queue[0] = seed;
      visited[seed] = 1;
      var bounds = [width, height, -1, -1];
      while (head < tail) {
        var point = queue[head++];
        var px = point % width;
        var py = Math.floor(point / width);
        bounds[0] = Math.min(bounds[0], px);
        bounds[1] = Math.min(bounds[1], py);
        bounds[2] = Math.max(bounds[2], px);
        bounds[3] = Math.max(bounds[3], py);
        var neighbors = [px > 0 ? point - 1 : -1, px < width - 1 ? point + 1 : -1, py > 0 ? point - width : -1, py < height - 1 ? point + width : -1, py < height - 1 ? point + width : -1];
        for (var n = 0; n < 4; n++) {
          var neighbor = neighbors[n];
          if (neighbor >= 0 && !visited[neighbor]) {
            visited[neighbor] = 1;
            queue[tail++] = neighbor;
          }
        }
      }
      if (tail < minComponent) continue;
      foreground += tail;
      left = Math.min(left, bounds[0]);
      top = Math.min(top, bounds[1]);
      right = Math.max(right, bounds[2]);
      bottom = Math.max(bottom, bounds[3]);
    }
    if (foreground / count < 0.05 || right < left) return null;
    // Two sample pixels of protection keep anti-aliased edges/shadows intact.
    left = Math.max(0, left - 2);
    top = Math.max(0, top - 2);
    right = Math.min(width, right + 3);
    bottom = Math.min(height, bottom + 3);
    return { x: left / width, y: top / height, width: (right - left) / width, height: (bottom - top) / height, background: alphaBackground ? [255, 255, 255] : bg.map(Math.round) };
  }

  function placement(bounds, sourceRatio, width, height) {
    var drawnWidth = Math.min(width, height * sourceRatio);
    var drawnHeight = drawnWidth / sourceRatio;
    var scale = Math.min(2.5, width * 0.96 / (drawnWidth * bounds.width), height * 0.96 / (drawnHeight * bounds.height));
    return {
      scale: scale,
      x: (0.5 - bounds.x - bounds.width / 2) * drawnWidth * scale,
      y: (0.5 - bounds.y - bounds.height / 2) * drawnHeight * scale
    };
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = { studioBounds: studioBounds, placement: placement };
    return;
  }
  if (window.__morayPdpMediaFit) return;
  window.__morayPdpMediaFit = true;
  var roots = new Map();

  function init(root) {
    if (roots.has(root)) return;
    var images = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-gallery] .iurop-pdp__img'));
    var fits = new Map();
    var disposers = [];
    var frame = 0;
    var stopped = false;
    function layout() {
      frame = 0;
      if (stopped) return;
      // Read all dimensions before writing styles; transforms don't resize
      // slides, change scroll offsets or affect the existing lightbox.
      var placements = [];
      fits.forEach(function (bounds, img) {
        var width = img.offsetWidth;
        var height = img.offsetHeight;
        if (width && height) placements.push({ img: img, fit: placement(bounds, img.naturalWidth / img.naturalHeight, width, height) });
      });
      placements.forEach(function (item) {
        var fit = item.fit;
        item.img.style.setProperty('--pdp-media-scale', fit.scale.toFixed(5));
        item.img.style.setProperty('--pdp-media-x', fit.x.toFixed(2) + 'px');
        item.img.style.setProperty('--pdp-media-y', fit.y.toFixed(2) + 'px');
      });
    }
    function schedule() {
      if (!frame && !stopped) frame = window.requestAnimationFrame(layout);
    }
    images.forEach(function (img) {
      function analyze() {
        if (stopped || fits.has(img) || !img.naturalWidth) return;
        try {
          var canvas = document.createElement('canvas');
          var ratio = img.naturalWidth / img.naturalHeight;
          canvas.width = Math.max(1, Math.round(128 * Math.min(1, ratio)));
          canvas.height = Math.max(1, Math.round(128 / Math.max(1, ratio)));
          var ctx = canvas.getContext('2d', { willReadFrequently: true });
          if (!ctx) return;
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          var bounds = studioBounds(ctx.getImageData(0, 0, canvas.width, canvas.height).data, canvas.width, canvas.height);
          img.dataset.pdpMediaFit = bounds ? 'studio' : 'photo';
          if (!bounds) {
            img.classList.remove('iurop-pdp__img--square-packshot');
            img.closest('[data-pdp-image]').classList.remove('iurop-pdp__slide--square-packshot');
            return;
          }
          fits.set(img, bounds);
          img.classList.add('iurop-pdp__img--studio');
          var slide = img.closest('[data-pdp-image]');
          slide.classList.add('iurop-pdp__slide--studio');
          slide.style.setProperty('--pdp-studio-background', 'rgb(' + bounds.background.join(',') + ')');
          schedule();
        } catch (_) {
          // A blocked canvas must never hide or break a photo. The server's
          // contain fallback stays in place for likely studio packshots.
          img.dataset.pdpMediaFit = 'fallback';
        }
      }
      img.addEventListener('load', analyze);
      disposers.push(function () { img.removeEventListener('load', analyze); });
      if (img.complete) analyze();
    });
    var observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    if (observer) observer.observe(root.querySelector('[data-pdp-track]') || root);
    window.addEventListener('resize', schedule, { passive: true });
    roots.set(root, function () {
      stopped = true;
      if (observer) observer.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener('resize', schedule);
      disposers.forEach(function (dispose) { dispose(); });
      roots.delete(root);
    });
  }
  function initAll() { document.querySelectorAll('[data-pdp]').forEach(init); }
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', function (event) {
    roots.forEach(function (dispose, root) { if (event.target === root || event.target.contains(root)) dispose(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
